import AccountPageDetails from "../components/pages/account/AccountPageDetails";
import AccountEditPage from "../components/pages/account/AccountEditPage";

const routes = [
    {
        path: "/account",
        element: <AccountPageDetails />
    },
    {
        path: "/account/edit",
        element: <AccountEditPage />
    },
    {
        path: "/account/create",
        element: <AccountEditPage />
    }
];

export default routes;
